import React from 'react';
import { InsightsMobileScreen } from '@/experiences/sales-portal/domain/insights/screens/insights-mobile-screen';
import { InsightsScreen } from '@/experiences/sales-portal/domain/insights/screens/insights-screen';
import { isWeb } from '@/utils/navigation';
import { LayoutSize, useLayoutContext } from '@/contexts/layout-context';

interface Props {
  supplierUUID: string;
}

/**
 * Routes Insights ("For You") to the phone or desktop screen.
 *
 * Matches the condition `SalesPortalTabBar` uses for the mobile bottom nav, so
 * the two always agree on what "phone" means: native only, so a narrow browser
 * window keeps the desktop screen rather than swapping layouts mid-resize.
 */
export const InsightsScreenWrapper: React.FC<Props> = ({ supplierUUID }) => {
  const { layoutSize } = useLayoutContext();
  const isMobileBottomNavLayout = !isWeb && layoutSize === LayoutSize.SMALL;

  if (isMobileBottomNavLayout) {
    return <InsightsMobileScreen supplierUUID={supplierUUID} />;
  }
  return <InsightsScreen supplierUUID={supplierUUID} />;
};
